import { DatePicker, Input, InputLabel } from '@trarc/pc-shared';
import moment from 'moment';
import { ChangeEvent } from 'react';

import { DateRange } from '../../types/api.graphql';
import { formatHTMLInputTime } from '../../utils/format';
import { PickersContainer } from './DateTimeInput.styles';

interface DateTimeInputProps {
  title?: string;
  selectedDate: Date;
  dateRange?: DateRange;
  setTimeLowOnChange?: boolean;
  onDateTimeChange: (dateTime: Date) => void;
  className?: string;
}

export const DateTimeInput = ({
  title,
  selectedDate,
  setTimeLowOnChange = true,
  dateRange = {},
  className,
  onDateTimeChange,
}: DateTimeInputProps) => {
  const onInputDateChange = (date: Date) => {
    const newDate = date ? moment(date) : moment();
    if (setTimeLowOnChange) {
      newDate.set('hours', 0);
      newDate.set('minutes', 0);
      newDate.set('seconds', 0);
    } else {
      newDate.set('hours', 23);
      newDate.set('minutes', 59);
      newDate.set('seconds', 59);
    }
    onDateTimeChange(newDate.toDate());
  };

  const onInputTimeChange = (e: ChangeEvent<HTMLInputElement>) => {
    const newDate = selectedDate ? moment(selectedDate) : moment();

    const fallbackTimeValues = setTimeLowOnChange ? [0, 0, 0] : [23, 59, 59];
    const [hours, minutes, seconds] = e.target?.value?.split(':')?.map(Number) || fallbackTimeValues;
    newDate.set('hours', hours);
    newDate.set('minutes', minutes);
    newDate.set('seconds', seconds);

    onDateTimeChange(newDate.toDate());
  };

  return (
    <div className={className}>
      {title && <InputLabel>{title}</InputLabel>}
      <PickersContainer>
        <DatePicker
          datePickerProps={{
            date: selectedDate,
            showYearDropdown: true,
            forceShowMonthNavigation: true,
            ...(dateRange?.min ? { minDate: new Date(dateRange.min) } : {}),
            ...(dateRange?.max ? { maxDate: new Date(dateRange.max) } : {}),
          }}
          onDateChange={onInputDateChange}
          ariaLabel=""
        />
        <Input
          type="time"
          step={2}
          value={selectedDate ? formatHTMLInputTime(selectedDate) : ''}
          onChange={onInputTimeChange}
        />
      </PickersContainer>
    </div>
  );
};
